import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ServiceOffersService } from "../../_services/serviceoffers.service";
import { CustomersService } from "../../_services/customers.service";
import { AgreementsService } from "../../_services/agreements.service";
import { StatisticsService } from "../../_services/statistics.service";
import { ServiceAddonsService } from "../../_services/serviceaddons.service";
import { CarsService } from "../../_services/cars.service";
import { Agreement } from "../../_models/agreement";
import { Dealer } from "../../_models/dealer";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { ServiceOffer } from "../../_models/serviceoffer";
import { ServiceAddon } from "../../_models/serviceaddon";
import { StatisticEvent } from "../../_models/statisticevent";
import { Customer } from "../../_models/customer";
import { Car } from "../../_models/car";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ArgumentOutOfRangeError, Subscription } from "rxjs";
import { CookieService } from 'ngx-cookie';
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { DealersService } from "../../_services/dealers.service";
import { EnvironmentService } from "app/_services";
import { NgForm } from "@angular/forms";

@Component({
	selector: 'app-dealerservicecheckout',
	templateUrl: './dealerservicecheckout.component.html',
  providers: [CarsService, DealersService, ServiceOffersService, ServiceAddonsService, CustomersService, AgreementsService, StatisticsService, CookieService]
})
export class DealerServiceCheckoutComponent implements OnInit {
  private serviceoffers: ServiceOffer[];
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  private data: Dealer;
  private statisticsService: StatisticsService;
  public hasResponded: boolean = false;

  private car: Car;
  private carid: string = "";
  private dealerId: string = "";
  private errorMessage: string = "";
  private isLoading: boolean = true;
  private calcStartupCost: boolean = true;
  private confirmation: boolean = false;

  private offerSpecialPrice: boolean = false;
  private specialPrice: number = null;

  public optin: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist: string;
  private carname: string = "";
  private payment_method: string = "";
  public startupPrice: number;
  public customer_data: Customer = new Customer();
  public agreement: Agreement;
  public pdf: any = "";
  public dealerSA: string = ""; //"Serviceaftale" nameing frontend

	private subscription: Subscription;
  private toasterService: ToasterService;
  private cookieService: CookieService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  private authenticateUrl = this.environmentService.getBaseURL() + "/";

	constructor(private carService: CarsService,
		toasterService: ToasterService,
    statisticsService: StatisticsService,
    cookieService: CookieService,
		private agreementsService: AgreementsService,
		private dealersService: DealersService,
		private customersService: CustomersService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private serviceAddonsService: ServiceAddonsService,
		private serviceoffersService: ServiceOffersService,
		private modalService: NgbModal,
		private environmentService: EnvironmentService,
		private http: Http) {
		this.toasterService = toasterService;
		this.statisticsService = statisticsService;
    this.activatedRoute = activatedRoute;
    this.cookieService = cookieService;
	}

  ngOnInit() {
    this.isLoading = false;
    this.dealerSA = "serviceabonnement";

    setInterval(function () {
      window.top.postMessage(document.body.scrollHeight, "*");
    }, 500);

		this.activatedRoute.params.subscribe(params => {
      this.carid = params["id"];
      this.agreement = JSON.parse(sessionStorage.getItem('agree'));
      if (this.agreement == null) {
        this.agreement = JSON.parse(this.cookieService.get('agree'));
      }
			this.agreement.sellerInitials = sessionStorage.getItem('sellerInitial');

      //If seller initials is set, present the special price option
      if (
        this.agreement.sellerInitials != null &&
        this.agreement.sellerInitials != ""
      ) {
        this.offerSpecialPrice = true;

        //Because the seller initials is set, we also check if the seller searched for a customer by using the reg.nr search
        if (sessionStorage.getItem("customer_reg_search") !== null) {
          this.setCustomerDataFromRegSearch();
        }
      }

			this.carService
				.get(this.carid)
				.subscribe(
					p => this.car = p,
					e => this.errorMessage = e,
          () => {
            if (this.errorMessage) {
              alert(this.errorMessage);
            }
						this.dealerId = this.car.dealer_id;
						if (this.dealerId == '63591e878c577855251e44b4') {
							this.dealerSA = 'serviceaftale';
						}
						this.dealersService
							.get(this.dealerId)
							.subscribe(
								p => {
									this.data = p;
								}
							);
					});

		});
	}

  saveAgreement(checkoutForm: NgForm) {
    checkoutForm.form.disable();
    this.isLoading = true;

    this.getAgreement(true, (agreementItem) => {
      if (this.agreement._id != undefined) {
        this.agreementsService.update(agreementItem).subscribe(
          (r) => {
            this.agreementDone();
          },
          (e) => {
            this.errorMessage = e;
            this.isLoading = false;
            checkoutForm.form.enable();
          }
        );
      } else {
        let customerItem = this.getCustomer();

        if (this.customer_data._id) {
          customerItem._id = this.customer_data._id;
          agreementItem.customer = this.customer_data._id;

          this.customersService.update(customerItem).subscribe(
            (r) => {},
            (e) => (this.errorMessage = e),
            () => {
              this.agreementsService.create(agreementItem).subscribe(
                (r) => {
                  this.agreementDone();
                  this.agreement = r;
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                  checkoutForm.form.enable();
                }
              );
            }
          );
        } else {
          this.customersService.create(customerItem).subscribe(
            (r) => (this.customer_data = r),
            (e) => (this.errorMessage = e),
            () => {
              agreementItem.customer = this.customer_data._id;

              this.agreementsService.create(agreementItem).subscribe(
                (r) => {
                  this.agreementDone();
                  this.agreement = r;
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                  checkoutForm.form.enable();
                }
              );
            }
          );
        }
      }

      let statisticEvent: StatisticEvent = new StatisticEvent();
      statisticEvent.customer = this.customer_data._id;
      statisticEvent.event = "dealer_checkout_complete";
      this.payment_method = this.customer_data.dealer[0].payment_method;
      this.statisticsService.sendEvent(statisticEvent).subscribe(
        /* happy path */ (r) => {
          console.log("checkout complete event tracked");
        },
        /* error path */ (e) => {
          this.errorMessage = e;
        }
      );
    });
  }

  private getAgreement(status, callback) {
    let agreementItem: Partial<Agreement> = {};

    if (this.agreement.sellerInitials && this.agreement.sellerInitials != "") {
      // The agreement type is a dealer
      agreementItem = this.agreement;
      agreementItem.calculatorType = "dealer";
      agreementItem.status = status;
      agreementItem.dealer_id = this.car.dealer_id;

      // If special price is set, then set the agreement price to that
      if (this.specialPrice != null) {
        agreementItem.price = this.specialPrice;
        agreementItem.specialOffer = true;
      }
      callback(agreementItem);
    } else {
      // Need to take variable copies here because we can't access them inside the 'subscribe' callback scope
      const agreementCopy = this.agreement;
      const carCopy = this.car;

      // Check if the end user is in the "email received" segment in Mautic
      this.customersService
        .hasMauticSegmentMembership(
          this.dealerId,
          this.customer_data.regnr,
          this.customer_data.email,
          "6-systemsegment---dashboard---serviceaftale---sendtmodtaget-email"
        )
        .subscribe(function (hasReceivedEmail) {
          agreementItem = agreementCopy;
          agreementItem.calculatorType = hasReceivedEmail ? "lead" : "dealer";
          agreementItem.status = status;
          agreementItem.dealer_id = carCopy.dealer_id;
          callback(agreementItem);
        });
    }
  }

  viewPDF(checkout) {
    if (checkout.valid) {
      this.getAgreement(false, (agreementItem) => {
        let customerItem = this.getCustomer();

        var tabWindowId = window.open("about:blank", "_blank");

        if (this.customer_data._id) {
          customerItem._id = this.customer_data._id;
          agreementItem.customer = this.customer_data._id;

          this.customersService.update(customerItem).subscribe(
            (r) => {},
            (e) => (this.errorMessage = e),
            () => {
              if (this.agreement._id == undefined) {
                this.agreementsService.create(agreementItem).subscribe(
                  (r) => {
                    this.agreement = r;
                    this.openPdf(tabWindowId, r);
                  },
                  (e) => {
                    this.errorMessage = e;
                    this.isLoading = false;
                  }
                );
              } else {
                this.agreementsService.update(agreementItem).subscribe(
                  (r) => {
                    this.openPdf(tabWindowId, this.agreement);
                  },
                  (e) => {
                    this.errorMessage = e;
                    this.isLoading = false;
                  }
                );
              }
            }
          );
        } else {
          this.customersService.create(customerItem).subscribe(
            (r) => (this.customer_data = r),
            (e) => (this.errorMessage = e),
            () => {
              if (this.agreement._id == undefined) {
                agreementItem.customer = this.customer_data._id;

                this.agreementsService.create(agreementItem).subscribe(
                  (r) => {
                    this.agreement = r;
                    this.openPdf(tabWindowId, r);
                  },
                  (e) => {
                    this.errorMessage = e;
                    this.isLoading = false;
                  }
                );
              } else {
                this.agreementsService.update(agreementItem).subscribe(
                  (r) => {
                    this.openPdf(tabWindowId, this.agreement);
                  },
                  (e) => {
                    this.errorMessage = e;
                    this.isLoading = false;
                  }
                );
              }
            }
          );
        }
      });
    }
  }

  previewPDF() {
    this.getAgreement(false, (agreementItem) => {
      let customerItem = this.getCustomer();

      var tabWindowId = window.open("about:blank", "_blank");

      if (this.customer_data._id) {
        customerItem._id = this.customer_data._id;
        agreementItem.customer = this.customer_data._id;

        this.customersService.update(customerItem).subscribe(
          (r) => {},
          (e) => (this.errorMessage = e),
          () => {
            if (this.agreement._id == undefined) {
              this.agreementsService.create(agreementItem).subscribe(
                (r) => {
                  this.agreement = r;
                  this.openpreviewPdf(tabWindowId, r);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            } else {
              this.agreementsService.update(agreementItem).subscribe(
                (r) => {
                  this.openpreviewPdf(tabWindowId, this.agreement);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            }
          }
        );
      } else {
        this.customersService.create(customerItem).subscribe(
          (r) => {
            this.customer_data = r;
            console.log("r:", r);
          },
          (e) => (this.errorMessage = e),
          () => {
            if (this.agreement._id == undefined) {
              agreementItem.customer = this.customer_data._id;
              this.agreementsService.create(agreementItem).subscribe(
                (r) => {
                  this.agreement = r;
                  this.openpreviewPdf(tabWindowId, r);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            } else {
              this.agreementsService.update(agreementItem).subscribe(
                (r) => {
                  this.openpreviewPdf(tabWindowId, this.agreement);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            }
          }
        );
      }
    });
  }
  previewTC() {
    this.getAgreement(false, (agreementItem) => {
      let customerItem = this.getCustomer();

      var tabWindowId = window.open("about:blank", "_blank");

      if (this.customer_data._id) {
        customerItem._id = this.customer_data._id;
        agreementItem.customer = this.customer_data._id;

        this.customersService.update(customerItem).subscribe(
          (r) => {},
          (e) => (this.errorMessage = e),
          () => {
            if (this.agreement._id == undefined) {
              this.agreementsService.create(agreementItem).subscribe(
                (r) => {
                  this.agreement = r;
                  this.openTC(tabWindowId, r);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            } else {
              this.agreementsService.update(agreementItem).subscribe(
                (r) => {
                  this.openTC(tabWindowId, this.agreement);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            }
          }
        );
      } else {
        this.customersService.create(customerItem).subscribe(
          (r) => (this.customer_data = r),
          (e) => (this.errorMessage = e),
          () => {
            if (this.agreement._id == undefined) {
              agreementItem.customer = this.customer_data._id;

              this.agreementsService.create(agreementItem).subscribe(
                (r) => {
                  this.agreement = r;
                  this.openTC(tabWindowId, r);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            } else {
              this.agreementsService.update(agreementItem).subscribe(
                (r) => {
                  this.openTC(tabWindowId, this.agreement);
                },
                (e) => {
                  this.errorMessage = e;
                  this.isLoading = false;
                }
              );
            }
          }
        );
      }
    });
  }

  private openpreviewPdf(tabWindowId: Window, agreement: Agreement) {
    this.isLoading = false;
    tabWindowId.location.href =
      this.authenticateUrl + "api/agreement/offer_" + agreement._id + ".pdf";
  }

  private openPdf(tabWindowId: Window, agreement: Agreement) {
    this.isLoading = false;
    tabWindowId.location.href =
      this.authenticateUrl +
      "api/agreement/agreement_" +
      agreement._id +
      ".pdf";
  }

  private openTC(tabWindowId: Window, agreement: Agreement) {
    this.isLoading = false;
    tabWindowId.location.href =
      this.authenticateUrl + "api/agreement/tc_" + agreement._id + ".pdf";
  }

  private getCustomer() {
    let customerItem: Customer = new Customer();
    customerItem.name = this.customer_data.name;
    customerItem.address = this.customer_data.address;
    customerItem.postnummer = this.customer_data.postnummer;
    customerItem.by = this.customer_data.by;
    customerItem.email = this.customer_data.email;
    customerItem.telefonnummer = this.customer_data.telefonnummer;
    customerItem.regnr = this.customer_data.regnr.replace(/ /g, "");
    customerItem.dealer = [];
    customerItem.dealer[0] = this.data;
    customerItem.car = this.car;
    customerItem.carBrand = this.customer_data.carBrand;
    customerItem.carKmStand = this.customer_data.carKmStand;
    customerItem.carYear = this.customer_data.carYear;

    return customerItem;
  }

  agreementDone() {
    this.isLoading = false;
    sessionStorage.removeItem("agree");
    sessionStorage.removeItem("sellerInitial");
    this.confirmation = true;
  }

  back() {
    window.history.back();
  }

  formatRegistration(value) {
    if (value) {
      value = value.toUpperCase();
      value = value.replace(/ /g, "");
      if (value.match(/^[A-Z]{2}\d*$/)) {
        if (value.length > 4) {
          value =
            value.substr(0, 2) +
            " " +
            value.substr(2, 2) +
            " " +
            value.substr(4);
        } else {
          value = value.substr(0, 2) + " " + value.substr(2);
        }
      }
    }

    this.customer_data.regnr = value;
  }

	setCustomerDataFromRegSearch() {
		const customer = JSON.parse(sessionStorage.getItem("customer_reg_search"));
		this.customer_data.name = customer.name;
		this.customer_data.address = customer.address;
		this.customer_data.by = customer.city;
		this.customer_data.postnummer = customer.postalcode;
		this.customer_data.email = customer.email;
		this.customer_data.regnr = customer.regnr;
	}
}



// WEBPACK FOOTER //
// ./src/app/landingpages/dealerservicecheckout/dealerservicecheckout.component.ts